import { Component, Vue } from 'vue-property-decorator';
import McIcon from '@/components/icons/mc-icon/mc-icon';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import FontAwesomeIcon from '@/components/icons/font-awesome-icon/font-awesome-icon';
import axios from 'axios';
import { partnersAPI } from '@/providers/apis/partners/partners';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import { PartnersModel } from '@/models/partners/partners';
import { mapDataSetAPI } from '@/providers/apis/app/map-dataset';
import { formatTime } from '@/utils/date';

@Component({
  name: 'partner-profile-details',
  components: {

    'google-material-icon': GoogleMaterialIcon,
    'font-awesome-icon': FontAwesomeIcon,
    'mc-icon': McIcon,
  },
})

export default class PartnerProfileDetails extends Vue {

   // -------------------------------------------------
  // Properties

  /**
   * Maintains the data of map plotting values
   */

  private partnerData: any = null;

  private summaryDataValue: boolean = true;

  private additionalInfoValue: boolean = true;

  private WorkDataValue: boolean = true;

  private countryDataValue: boolean = true;

  private videoDataValue: boolean = true;

  private linkDataValue: boolean = true;

  private videoContainer: any = [];

  private addtionalLinkdata: any = [];

  private videoResponceData: any = [];

  private addtionalLinkResponceData: any = [];

  private selectedImage: string = '';

  // -------------------------------------------------
  // Hooks
  private created() {
    const partnerProfileData = this.fetchPartnerProfileMapData();
    partnerProfileData.then((data) => {
      this.partnerData = data[0];
    });
    const defaultVideo = this.videoResponceData;
    this.videoContainer = defaultVideo.slice(0, 2);
    const defaultAddtionalValue = this.addtionalLinkResponceData;
    this.addtionalLinkdata = defaultAddtionalValue.slice(0, 3);

  }

  // --------------------------------------------------
  // Methods
  private fetchPartnerProfileMapData() {
    return axios.all([
      partnersAPI.getPartnerById(this.$route.params.id),
    ]);
  }

  private formatTime(value: number) {
    return formatTime(value);
  }

  // --------------------------------------------------
  // Actions
  private back() {
    this.$router.back();
  }

  private onClickVideo() {
    const count = this.videoContainer.length + 2;
    if (this.videoContainer.length !== this.videoResponceData.length) {
      const videoValue = this.videoResponceData;
      this.videoContainer = videoValue.slice(0, count);
    }
  }

  private onClickAddtionalLink() {
    const count = this.addtionalLinkdata.length + 3;
    if (this.addtionalLinkdata.length !== this.addtionalLinkResponceData.length) {
      const addtionalValue = this.addtionalLinkResponceData;
      this.addtionalLinkdata = addtionalValue.slice(0, count);
    }
  }

  private imgLoad() {
    const partnerImage = this.$refs.partnerImage as any;
    partnerImage[0].style.display = 'block';
  }


}
